import { render, staticRenderFns } from "./Bagy.vue?vue&type=template&id=49734584&"
import script from "./Bagy.vue?vue&type=script&lang=js&"
export * from "./Bagy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports